import { dateBadge, sportName } from "@/lib/helpers";

export const STATUS_CLS = {
  draft: "bg-slate-100 text-slate-600", payment_pending: "bg-amber-100 text-amber-700",
  pending_approval: "bg-blue-100 text-blue-700", approved: "bg-emerald-100 text-emerald-700",
  published: "bg-emerald-100 text-emerald-700", rejected: "bg-red-100 text-red-700", expired: "bg-slate-100 text-slate-500",
};

export function StatusBadge({ status }) {
  return <span className={`text-xs font-semibold px-2 py-0.5 rounded capitalize ${STATUS_CLS[status] || "bg-slate-100"}`}>{(status || "").replace(/_/g, " ")}</span>;
}

export function AdminHeader({ title, subtitle }) {
  return (
    <div className="mb-6">
      <h1 className="font-display font-black uppercase tracking-wide text-3xl text-[#0f172a]">{title}</h1>
      {subtitle && <p className="text-slate-500 mt-1">{subtitle}</p>}
    </div>
  );
}

export function timeAgo(iso) {
  if (!iso) return "";
  const d = new Date(iso);
  const s = Math.floor((Date.now() - d.getTime()) / 1000);
  if (s < 60) return "just now";
  if (s < 3600) return `${Math.floor(s / 60)}m ago`;
  if (s < 86400) return `${Math.floor(s / 3600)}h ago`;
  return `${Math.floor(s / 86400)}d ago`;
}

export { dateBadge, sportName };
